import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import LiveChatWidget from "./components/LiveChatWidget";
import Home from "./components/Home";
import Footer from "./components/Footer";
import Offerbar from "./components/Offerbar";
import Navbar from "./components/Navbar";
import IconSlide from "./components/IconSlide";
import LoginModel from "./components/LoginModel";
import Viewall from "./components/Viewall";
import Cart from "./components/Cart";
import Payment from "./components/Payment";
import Mens from "./components/Mens";
import Jewellery from "./components/Jewellery";

// Product Details Page
import ProductDetails from "./components/ProductDetails";

// Contexts
import { CartProvider } from "./components/CartContext";
import { CountryProvider } from "./components/CountryContext";

function App() {

  // =========================
  // AOS INITIALIZATION
  // =========================

  useEffect(() => {

    AOS.init({
      duration: 1200,
      once: true,
      easing: "ease-in-out",
    });

  }, []);

  return (

    <BrowserRouter>

      {/* =========================
          COUNTRY CONTEXT
      ========================== */}

      <CountryProvider>

        {/* =========================
            CART CONTEXT
        ========================== */}

        <CartProvider>

          {/* =========================
              HEADER
          ========================== */}

          <Offerbar />

          <Navbar />

          <IconSlide />

          <LoginModel />

          {/* =========================
              MAIN ROUTES
          ========================== */}

          <Routes>

            {/* =========================
                HOME PAGE
            ========================== */}

            <Route
              path="/"
              element={<Home />}
            />

            {/* =========================
                VIEW ALL / WOMEN PAGE
            ========================== */}

            <Route
              path="/view-all"
              element={<Viewall />}
            />

            {/* =========================
                MENS COLLECTION
            ========================== */}

            <Route
              path="/mens"
              element={<Mens />}
            />

            {/* =========================
                MENS PRODUCT DETAILS
                IDs: 1 - 8
            ========================== */}

            <Route
              path="/product/:id"
              element={<ProductDetails />}
            />

            {/* =========================
                WOMENS + FEATURED +
                HOME PRODUCT DETAILS

                Women's IDs: 101 - 133
                Home IDs: 201 - 208
                Featured IDs: 301 - 310
            ========================== */}

            <Route
              path="/womens/:id"
              element={<ProductDetails />}
            />

            {/* =========================
                CART
            ========================== */}

            <Route
              path="/cart"
              element={<Cart />}
            />

            {/* =========================
                PAYMENT
            ========================== */}

            <Route
              path="/payment"
              element={<Payment />}
            />

            {/* =========================
                JEWELLERY
            ========================== */}

            <Route
              path="/jewellery"
              element={<Jewellery />}
            />

          </Routes>

          {/* =========================
              FOOTER
          ========================== */}

          <Offerbar />

          <Footer />

          {/* =========================
              LIVE CHAT
          ========================== */}

          <LiveChatWidget />

        </CartProvider>

      </CountryProvider>

    </BrowserRouter>
  );
}

export default App;

